import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetDeviceNumDetail() {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPile/getDeviceNumDetail`,
  });
}
